import { LayoutTypes } from "@enums/layout-types";
import { useMemo } from "react";
import styles from "./form-group-wrapper.less";
import classNames from "classnames";
import { IdwFormLabelWithIconContainer } from "@containers/common/idw-form-label-with-icon-container/idw-form-label-with-icon-container";
import { LabelWidthTypes } from "@enums/label-width-types";

type FormGroupWrapperProps = {
    id: string;
    label: string;
    isRequired: boolean;
    layout: LayoutTypes;
    children: React.ReactNode;
    className: string;
    labelWidth?: LabelWidthTypes;
}

export const FormGroupWrapper = ({ id, label, isRequired, layout, labelWidth = LabelWidthTypes.MEDIUM, className, children }: FormGroupWrapperProps) => {

    const formGroupClassName = useMemo(() => {
        return layout === LayoutTypes.COLUMN ? styles.formGroupColumn : styles.formGroupRow;
    }, [layout]);

    return (
        <div className={classNames(formGroupClassName, className)}>
            {label && (
                <IdwFormLabelWithIconContainer
                    controlId={`attribute-input-label-${id}`}
                    label={label}
                    isRequired={isRequired}
                    layout={layout}
                    labelWidth={labelWidth}
                />)}

            <div className={styles.formGroupInputContainer}>{children}</div>
        </div>
    );
}